/*
 * Base is the default environment for production.
 * Add everything here and override value in other files if needed.
 * https://blog.usejournal.com/my-awesome-custom-react-environment-variables-setup-8ebb0797d8ac
 */
export default function baseEnv(baseApi: string, baseApiV2: string) {
    return {
        route: {
            baseRoute: process.env.PUBLIC_URL ? process.env.PUBLIC_URL : '/',
        },
        api: {
            validateAccount: `${baseApi}/webapi/auth/validateAccount`,
            signIn: `${baseApi}/webapi/auth/signIn`,
            handshakeLogin: `${baseApi}/servicesv2/application/fxn`,
            handshakeChallenge: `${baseApi}/servicesv2/application/fxn`,
            handshakeRecipient: `${baseApi}/servicesv2/application/fxn`,
            token: `${baseApi}/webapi/auth/token`,
            doTransferFx: `${baseApi}/webapi/transfer/doTransferFx`,
            doOperationFx: `${baseApi}/webapi/transfer/doOperationFx`,
            requestDoPhysicalNational: `${baseApiV2}/recipients/physical/national`,
            requestDoPhysicalForeing: `${baseApiV2}/recipients/physical/foreign`,
            requestDoCompanyNational: `${baseApiV2}/recipients/company/national`,
            requestDoCompanyForeing: `${baseApiV2}/recipients/company/foreign`,
            requestDoGetDataRecipient: `${baseApiV2}/recipients/find/one`,
            requestDoDeleteDataRecipient: `${baseApiV2}/recipients/`,
            errorExample: '',
        },
        isProduction: true,
        isDevelopment: false,
        isTesting: false,
    };
}

export type Environment = ReturnType<typeof baseEnv>;
